import React from 'react';
import clsx from 'clsx';

import scss from './AssetGrid.module.scss';

function AssetGrid({ isCompact = false, children }) {
  return <ul className={clsx(scss.grid, isCompact && scss.compact)}>{children}</ul>;
}

export default AssetGrid;
